import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/about/team.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionDiv"] */ "/vercel/path0/components/ui/animateOnEnter.tsx");
